import { FC, useState } from "react";
import { Facture } from "../../lib/interfaces/facture.interface";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import axiosClient from "../../lib/axiosClient";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "sonner";
import Title from "../ui/Title";
import Divider from "../ui/Divider";

interface Props {
  facture: Facture;
}

const CommentPayerFactureDialog: FC<Props> = ({ facture }) => {
  const [loading, setLoading] = useState(false);
  const payerParCarte = async () => {
    try {
      setLoading(true);
      const { data: stripeCheckoutSessionId } = await axiosClient.post<string>(
        `/paiement/creer-stripe-checkout-session-pour-facture`,
        { factureId: facture.id }
      );
      const stripe = await loadStripe(
        facture.sna
          ? `${import.meta.env.VITE_SNA_STRIPE_KEY}`
          : `${import.meta.env.VITE_STRIPE_KEY}`
      );
      stripe?.redirectToCheckout({ sessionId: stripeCheckoutSessionId });
    } catch (error) {
      toast.error(
        "Une erreur s'est produite. Veuillez réessayer ultérieurement ou choisir un autre mode de paiement."
      );
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button>Comment payer ma facture ?</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] max-h-screen overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            <Title order={2}> Comment payer la facture ?</Title>
          </DialogTitle>
        </DialogHeader>
        <Divider />

        {/* Carte bancaire */}
        {facture.montant >= 50 && (
          <>
            <Title order={3}>Par carte bancaire</Title>
            <div>
              Cliquez sur le bouton ci-dessous pour être redirigé vers le
              portail de paiement.
            </div>
            <div>
              <Button onClick={payerParCarte} loading={loading}>
                {loading ? "Redirection..." : "Payer par carte bancaire"}
              </Button>
            </div>
          </>
        )}

        <Divider className="my-2" />

        {/* Virement */}
        <Title order={3}>Par virement bancaire</Title>
        <div>
          Veuillez envoyer un virement de <strong></strong>
          <strong>{(facture.montant / 100).toFixed(2)}€</strong> en indiquant
          comme référence le numéro de facture <strong>{facture.numero}</strong>
          .
        </div>
        <div className="italic">
          <strong>IBAN</strong> :{" "}
          {facture.sna
            ? "FR05 3000 2004 3800 0000 7188 H31"
            : "FR38 3000 2004 3800 0000 7191 U50"}
          <br />
          <strong>BIC</strong> : CRLYFRPP
        </div>

        <Divider className="my-2" />

        {/* Virement */}
        <Title order={3}>Par chèque</Title>
        <div>
          Veuillez envoyer un chèque de <strong></strong>
          <strong>{(facture.montant / 100).toFixed(2)}€</strong> à l'ordre{" "}
          {facture.sna
            ? "du Syndicat National d'Apiculture"
            : "de l'Abeille de France"}{" "}
          en indiquant comme référence le numéro de facture{" "}
          <strong>{facture.numero}</strong>, à l'adresse postale : <br />
        </div>
        <div className="italic">
          <strong>
            {facture.sna
              ? "Syndicat National d'Apiculture"
              : "L'Abeille de France"}
          </strong>
          <br />5 rue de Copenhague
          <br />
          75008 Paris
          <br />
          France
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant={"outline"}>Fermer</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CommentPayerFactureDialog;
